module.exports = __webpack_public_path__ + "img/watage_res_4.87cef4c4.gif";